module.exports = __webpack_public_path__ + "img/cow.0a0ebfc6.svg";